module.exports = __webpack_public_path__ + "img/music-work-icon16.d7f1380e.png";